import { Component, OnInit } from '@angular/core';
import { config } from '../../../../../../environments/config';
import { ConfirmationService, LazyLoadEvent, Message } from 'primeng/primeng';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Candidate } from '../../../class/candidate';
import { MedicalCaseEvent } from '../../../class/medical-case-event';
import { MedicalCasesEventService } from '../../../service/medical-cases-event/medical-cases-event.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { MedicalCaseEventCandidateSharedService } from '../../../service/medical-case-event-candidate/medical-case-event-candidate-shared.service';

@Component({
  selector: 'app-medical-cases-event',
  templateUrl: './medical-cases-event.component.html',
  styleUrls: ['./medical-cases-event.component.scss']
})
export class MedicalCasesEventComponent implements OnInit {

  public apiUrl = config.API_ROOT;

  public modNew = false;
  public modView = false;

  public medicalCasesEvent: MedicalCaseEvent[];

  // public citations: Attendance[];
  // public candidate: Candidate[];

  public loading: boolean = true;

  public page: number;
  public per_page: number;
  public sort: string;
  public query: string;
  public candidate_id: string;

  public es: any;

  public msgs: Message[] = [];

  public myEmployeeId: string;

  public filters: any[];

  public first = 0;
  public totalRecords: number;

  public form1: FormGroup;

  public modExportReport: boolean;

  public sticky: boolean = false;
  public dataGeneral: any;
  public statusOptions: any[];
  


  constructor(public fb: FormBuilder, 
              public medicalCasesEventService: MedicalCasesEventService,
              public medicalCaseEventCandidateSharedService: MedicalCaseEventCandidateSharedService,
              public router: Router,
              public route: ActivatedRoute,
              public confirmationService: ConfirmationService,
              public notificationsService: NotificationsService,
              public translate: TranslateService) { }

  ngOnInit() {
    this.candidate_id = this.route.snapshot.paramMap.get('candidate_id');
    this.medicalCaseEventCandidateSharedService.fetchDataById(this.candidate_id).subscribe(candidate => {
      this.dataGeneral = candidate;
    });
    this.statusOptions = [
      {label: 'Todos', value: ''},
      {label: 'Abierto', value: 'Abierto'},
      {label: 'Cerrado', value: 'Cerrado'},
    ];
    this.page = 1;
    this.per_page = 10;
    this.sort = '-id';

    this.myEmployeeId = JSON.parse(localStorage.getItem('profile')).employee_id;

    this.createForm1();

  }

  createForm1(data:any = null){
    data = data || {
      // company_id_filter : '',
      // candidate_id_filter : '',
      // venue_id_filter : '',
      status_filter:''
    };

    this.form1 = this.fb.group({
      // company_id_filter : new FormControl(data.company_id_filter),
      // candidate_id_filter : new FormControl(data.candidate_id_filter),
      // venue_id_filter : new FormControl(data.venue_id_filter),
      status_filter: new FormControl(data.status_filter)
    });
  }

  public filter (values?, pageRefresh?) {
    this.page = 1;
    this.first = 0;

    this.filters = [];
    this.filters.push({'key': 'candidate_id', 'value': this.candidate_id});

    // if (values.candidate_id_filter !== 'all' && values.candidate_id_filter !== '')
    //   this.filters.push({'key': 'candidate_id-lk', 'value': values.candidate_id_filter.id});

    // if (values.company_id_filter !== 'all' && values.company_id_filter !== '')
    //   this.filters.push({'key': 'company_id-lk', 'value': values.company_id_filter.id});

    // if (values.venue_id_filter)
    //   this.filters.push({'key': 'venue_id-lk', 'value': values.venue_id_filter});
    if (values.status_filter  && values.status_filter !== '')
      this.filters.push({'key': 'status-in', 'value': values.status_filter});

    this.getMedicalCasesEvents();
  }

  public getMedicalCasesEvents(query?: string) {
    this.loading = true;
    this.medicalCasesEventService.getMedicalCasesEvent(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
      response => {
        this.loading = false;

        this.medicalCasesEvent = response.json().data;
        this.totalRecords = response.json().meta.total;
      },
      error => {
        this.loading = false;
        this.msgs = [];
        this.msgs.push( { severity: 'error', summary: 'error' } );
      }
    );
  }

  public loadMedicalCasesEventsLazy(event: LazyLoadEvent) {
    this.page = (event.first / this.per_page) + 1;

    if (event.sortOrder === -1)
      this.sort =  '-' + event.sortField;
    else
      this.sort =  event.sortField;

    if (event.globalFilter)
      this.query = event.globalFilter;
    else
      this.query = undefined;

    this.sort = '-id';

    this.filter(this.form1.value);
  }
  
  public edit(medicalCaseEvent: any) {
    this.router.navigate(['/pages/medical-cases/events/'+ medicalCaseEvent.candidate_id + '/' + medicalCaseEvent.id]);
  }

  public back()
  {
    this.router.navigate(['/pages/medical-cases']);
  }
  
  public deleteDialog(medicalCaseEvent: MedicalCaseEvent) {
    let message;
    this.translate.get('Do you want to delete?').subscribe((res: string) => {
        message = res;
    });

    let header;
    this.translate.get('Delete Confirmation').subscribe((res: string) => {
        header = res;
    });

    this.confirmationService.confirm({
        message: message,
        header: header,
        icon: 'fa fa-trash',
        accept: () => {
            this.delete(medicalCaseEvent);
        }
    });
  }

  public delete(medicalCaseEvent: MedicalCaseEvent) {
      this.medicalCasesEventService.deleteMedicalCaseEvent(medicalCaseEvent.id).toPromise().then(
        response => {
            this.msgs = [];
            this.msgs.push( { severity: 'success', summary: 'deleted' } );
            this.getMedicalCasesEvents();
        },
        error => {
          let msg = 'delete';
          let msg_error = error._body;
          this.translate.get('error').subscribe((res: string) => {
              this.translate.get(msg).subscribe((res1: string) => {
                  this.notificationsService.growlNotify('error', res + ' '+ res1 + msg_error );
              })
          });
        }
      );
  }

  getCardTitle(): string {
    const baseTitle = this.translate.instant('tracking'); // Asumiendo que estás usando ngx-translate
    var msg = baseTitle; 
    
    if(this.dataGeneral != undefined) 
    {
      var name = this.dataGeneral.candidate_name;
      if(this.dataGeneral.candidate_name == undefined)
        name = this.dataGeneral.name;
      msg += ' : ' + name + ' , NUMERO DOCUMENTO : ' + this.dataGeneral.identification_number;
    }  
    return msg;
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/medical-cases/medical-cases-event/medical-cases-event.component.ts